const serverUrl = process.env.REACT_APP_SERVER_URL || 'https://flightfinder.cc';

export default serverUrl;
